import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-2 grid-gap-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Назначение контейнеров",
    overflow: false,
    loading: _ctx.isLoading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        value: _ctx.state.courier_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courier_id) = $event)),
        placeholder: "Выберите курьера",
        options: _ctx.couriers_state.list,
        loading: _ctx.couriers_state.is_loading,
        failed: _ctx.couriers_state.is_failed,
        "error-text": "При получении списка курьеров произошла ошибка",
        label: "fullName",
        "search-without-refresh": "",
        disabled: _ctx.loading || _ctx.state.provider_id,
        "is-invalid": _ctx.validation$.courier_id.$error,
        "validation-errors": _ctx.validation$.courier_id.$errors,
        "search-by": "fullName",
        "can-deselect": ""
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"]),
      (_ctx.isProviders)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providers_state.list, (provider, idx) => {
              return (_openBlock(), _createBlock(_component_new_checkbox, {
                key: `provider-${idx}`,
                class: "checkbox--blue mt-3",
                value: _ctx.isProviderChecked(provider.id),
                label: provider.name,
                disabled: _ctx.loading || _ctx.state.courier_id,
                "onUpdate:value": ($event: any) => (_ctx.onProviderChange(provider.id))
              }, null, 8, ["value", "label", "disabled", "onUpdate:value"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}